export const getPackSize = (packId) => ({ packSizes }) =>
  packSizes.packsList.find(({ id }) => id === packId);
